import {
  makeStyles,
  Typography,
  Button,
  ButtonProps,
} from "@material-ui/core";
import printIcon from '../assets/icons/printIcon.svg';
import { ITheme } from "../constants/theme";
import { textButtonHoverAndActive } from "../utils/styles/buttonStyles";
import { useTranslation } from 'react-i18next';

interface IProps extends ButtonProps { }

export const PrintItemsButton = (props: IProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Button className={classes.button} onClick={props.onClick} disabled={props.disabled}>
      <img
        src={printIcon}
        className={classes.icon}
        alt="printIcon"
      />
      <Typography
        variant="button"
        component="span"
        color="primary"
        data-automation="print-item-list-button"
        className={classes.text}
      >
        {t('orderDetails.printItemList')}
      </Typography>
    </Button>
  );
};

const useStyles = makeStyles((theme: ITheme) => ({
  button: {
    borderRadius: "8px",
    ...textButtonHoverAndActive
  },
  text: {
    textTransform: "none",
  },
  icon: {
    width: "18px",
    height: "18px",
    marginRight: 8,
  },
}));